import React from 'react';
import { LucideIcon } from 'lucide-react';

interface ServiceCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ 
  icon: Icon, 
  title, 
  description 
}) => {
  return (
    <div className="group relative p-8 bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300">
      {/* Gradient hover effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-500/0 via-indigo-500/0 to-violet-500/0 group-hover:from-blue-500/5 group-hover:via-indigo-500/5 group-hover:to-violet-500/5 rounded-2xl transition-all duration-300" />
      
      <div className="relative">
        <div className="inline-flex p-3 bg-blue-50 rounded-xl group-hover:bg-blue-100 transition-colors duration-300">
          <Icon className="h-8 w-8 text-blue-600" />
        </div>
        
        <h3 className="mt-6 text-xl font-semibold text-gray-900 group-hover:text-blue-600 transition-colors duration-300">
          {title}
        </h3>
        
        <p className="mt-4 text-gray-600 group-hover:text-gray-700 transition-colors duration-300">
          {description}
        </p>

        {/* Decorative elements */}
        <div className="absolute -right-2 -top-2 w-2 h-2 bg-blue-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute -left-2 -bottom-2 w-2 h-2 bg-violet-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>
    </div>
  );
};

export default ServiceCard;